__turbopack_context__.v({
  "basket": "styles-module-scss-module__QVHpvW__basket",
  "basket__main": "styles-module-scss-module__QVHpvW__basket__main",
  "basket__section": "styles-module-scss-module__QVHpvW__basket__section",
  "basket__sidebar": "styles-module-scss-module__QVHpvW__basket__sidebar",
  "content": "styles-module-scss-module__QVHpvW__content",
  "header": "styles-module-scss-module__QVHpvW__header",
  "headerWrapper": "styles-module-scss-module__QVHpvW__headerWrapper",
  "main": "styles-module-scss-module__QVHpvW__main",
  "recommended__products": "styles-module-scss-module__QVHpvW__recommended__products",
  "root": "styles-module-scss-module__QVHpvW__root",
  "subtitle": "styles-module-scss-module__QVHpvW__subtitle",
  "title": "styles-module-scss-module__QVHpvW__title",
  "types": "styles-module-scss-module__QVHpvW__types",
});
